module.exports = __webpack_public_path__ + "static/media/visitorid.4be71afd.png";